import { IsoIntervalStr } from '@elderbyte/ngx-starter'
import { WeekSchedule, WorkSchedule } from '../../schedules/work-schedule'

export enum FacilityScheduleType {
  WORK = 'WORK',
}

export class FacilitySchedule extends WorkSchedule {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public id: string // ObjectId

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor(
    /**
     * The facility
     */
    public facilityId: string,
    public override name: string,
    public type: FacilityScheduleType,
    /**
     * The scope in which this performance schedule is applicable.
     */
    public override validityInterval: IsoIntervalStr,
    /**
     * The week schedule
     */
    public override weekSchedule: WeekSchedule = new WeekSchedule()
  ) {
    super(name, validityInterval, weekSchedule)
  }
}
